import React from "react";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import SidebarIcon from "./SidebarIcon";
import { sidebarIcons } from "./sidebarIcons";
import styles from "./SidebarLayout.module.css";

type SidebarSectionProps = {
  title: string;
  icon?: IconDefinition;
  compact?: boolean;
  collapsible?: boolean;
  expanded?: boolean;
  onToggle?: () => void;
  onExpandSidebar?: () => void;
  children: React.ReactNode;
};

function SidebarSection({
  title,
  icon,
  compact = false,
  collapsible = false,
  expanded = true,
  onToggle,
  onExpandSidebar,
  children,
}: SidebarSectionProps) {
  const titleContent = (
    <span
      className={`${styles.sectionTitleGroup} ${compact ? styles.sectionTitleGroupCompact : ""}`}
      title={compact ? title : undefined}
    >
      {icon && <SidebarIcon icon={icon} className={styles.sectionIcon} />}
      {!compact && <span>{title}</span>}
    </span>
  );

  if (compact) {
    return (
      <section className={`${styles.section} ${styles.sectionCompact}`}>
        {icon && (
          <button
            type="button"
            className={styles.compactSectionButton}
            onClick={onExpandSidebar}
            aria-label={title}
            title={title}
          >
            <SidebarIcon icon={icon} className={styles.sectionIcon} />
          </button>
        )}
      </section>
    );
  }

  return (
    <section className={styles.section}>
      {collapsible ? (
        <button
          type="button"
          className={`${styles.sectionLabel} ${styles.sectionToggle}`}
          onClick={onToggle}
          aria-expanded={expanded}
        >
          {titleContent}
          <SidebarIcon
            icon={sidebarIcons.sectionToggle}
            size="sm"
            muted
            className={`${styles.toggleIcon} ${expanded ? styles.toggleIconExpanded : ""}`}
          />
        </button>
      ) : (
        <div className={`${styles.sectionLabel} ${styles.sectionLabelStatic}`}>
          {titleContent}
        </div>
      )}

      {expanded && children}
    </section>
  );
}

export default SidebarSection;
